"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCheckResponseMapper = void 0;
var CreditCheckResponseMapper = /** @class */ (function () {
    function CreditCheckResponseMapper(data) {
        this.localData = data;
    }
    CreditCheckResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CreditCheckResponseMapper;
}());
exports.CreditCheckResponseMapper = CreditCheckResponseMapper;
//# sourceMappingURL=CreditCheckResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CreditCheckResponseMapper.js
// module id = 2077
// module chunks = 8